import { withLazyComponent } from './with-lazy-component';
import React from 'react';

const AddressStrict = React.lazy(() => import('../components/address-strict-test'));

export default function (dependencies) {
  const { language } = dependencies;

  const html = (props) => {
    const LazyComponent = withLazyComponent(AddressStrict);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    validators: [
      function (state, config, globalConfig) {
        if (state.match == 'full') {
          return false;
        } else {
          return language['address-invalid'];
        }
      },
    ],
    config: {
      behaviour: 'text-input',
    },
  };
}
